export const ApiUrl = "https://api.lincolnshirestatics.com/api/";
export const StaticUrl = "https://api.lincolnshirestatics.com/";
export const PublicUrl = "https://api.lincolnshirestatics.com/storage/images/uploads/";
export const AssetsUrl = "https://api.lincolnshirestatics.com/storage/images/assets/";
export const ProfileUrl = "https://api.lincolnshirestatics.com/storage/images/profile/";
export const PhotosArchivesUrl = "https://api.lincolnshirestatics.com/storage/images_archives/";
export const PublicVideoUrl = "https://api.lincolnshirestatics.com/storage/videos/uploads/";

export const makeImgUrl = (ref,size,filename) => {

    return PublicUrl + ref + "/" + size + '/' + filename;
}

export const makeProfileImgUrl = (user) => {

    return user ? ProfileUrl + user.id + "/" + user.photo : null;
}

export const makeVideoUrl = (filename) => PublicVideoUrl + filename;
